import { render } from "./SectionFeatures.vue?vue&type=template&id=7541cf6f&scoped=true"
import script from "./SectionFeatures.vue?vue&type=script&lang=js"
export * from "./SectionFeatures.vue?vue&type=script&lang=js"

import "./SectionFeatures.vue?vue&type=style&index=0&id=7541cf6f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7541cf6f"]])

export default __exports__